import { trackBoardsProductRemoveFromBoardSubmit } from "@faire/web-api/events/boards/submit/productRemoveFromBoard";
import { IProduct } from "@faire/web-api/indigofair/data/IProduct";
import { useEffectEvent } from "@faire/web/ui/hooks/useEffectEvent";

import { getPromotedByString } from "@faire/retailer/hooks/ProductTileImpression/__internal__/getPromotedByString";
import { useProductTileClickImpressionContext } from "@faire/retailer/hooks/ProductTileImpression/useProductTileClickImpressionContext";

export const useRecordRemoveFromBoardSubmitEvent = (
  token: string | undefined,
  impressionId: string | undefined,
  promotedBy: Array<keyof typeof IProduct.PromotedType> | undefined,
  recordImpressions = false
) => {
  const { context, requestId } = useProductTileClickImpressionContext();

  return useEffectEvent((boardToken?: string) => {
    if (!token || !recordImpressions || !boardToken) {
      return;
    }

    const eventPromotedByString = getPromotedByString(promotedBy);
    trackBoardsProductRemoveFromBoardSubmit(
      context,
      requestId ?? "",
      token,
      eventPromotedByString,
      boardToken,
      impressionId ?? ""
    );
  });
};
